import VouchersApi from '../../apis/Voucher';

export default {
    namespaced: true,
    state: {
        vouchers: [],
        voucher_response: null
    },
    mutations: {
        set_vouchers (state, data) {
            state.vouchers = data;
        },
        set_voucher_response (state, value) {
            state.voucher_response = value;
        }
    },
    actions: {
        async getVouchers({commit, dispatch}, filters) {
            commit('set_voucher_response', null);
            return await VouchersApi.get_all(filters)
                .then( response => {
                    commit('set_vouchers', response.data)
                })
                .catch( error => {
                    commit('set_voucher_response', 'error');
                })
        },
        async store({commit, dispatch}, voucher) {
            commit('set_voucher_response', null);
            return await VouchersApi.store(voucher)
                .then( response => {
                    commit('set_voucher_response', 'success');
                    dispatch('getVouchers');
                })
                .catch( error => {
                    commit('set_voucher_response', 'error');
                })
        },
        async update({commit, dispatch}, voucher) {
            commit('set_voucher_response', null);
            return await VouchersApi.update(voucher)
                .then( response => {
                    commit('set_voucher_response', 'success');
                    dispatch('getVouchers')
                })
                .catch( error => {
                    commit('set_voucher_response', 'error');
                })
        },
        async change_status({commit, dispatch}, voucher) {
            commit('set_voucher_response', null);
            return await VouchersApi.change_status(voucher)
                .then( response => {
                    commit('set_voucher_response', 'success');
                    dispatch('getVouchers')
                })
                .catch( error => {
                    commit('set_voucher_response', null);
                })
        },
    }
}